import { forwardRef } from 'react';
import { DialogModalClose } from './dialog_modal_close.component';
import { DialogModalContent } from './dialog_modal_content.component';
import { DialogModalDescription } from './dialog_modal_description.component';
import { DialogModalFooter } from './dialog_modal_footer.component';
import { DialogModalRoot } from './dialog_modal_root.component';
import { DialogModalTitle } from './dialog_modal_title.component';

export const DialogModal = {
	Root: DialogModalRoot,
	Title: forwardRef(DialogModalTitle),
	Description: forwardRef(DialogModalDescription),
	Content: forwardRef(DialogModalContent),
	Footer: forwardRef(DialogModalFooter),
	Close: forwardRef(DialogModalClose),
} as const;

export type { DialogModalRootProps, DialogModalSize } from './dialog_modal_root.component';
